<template>
	<div class="row">
		<div class="col-12">
			<div class="flex-table">
				<div class="flex-table--row">
					<div class="flex-table--cell flex-table--cell-grow-always">
						<h5 class="job-information-card--header-title">PDF Statement Page</h5>
					</div>
				</div>
				<div class="flex-table--row">
					<div class="flex-table--cell flex-table--cell-grow-always">
						<redactor
							v-model="body"
							:config="{
								formatting: ['p', 'h1', 'h2', 'h3'],
								buttons: ['format', 'bold', 'italic', 'ul'],
								plugins: ['fontcolor'],
								minHeight: '300px'
							}"
							name="body"
						></redactor>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Redactor from "../../general_components/Redactor";
export default {
	name: "PDFSettingsPage",
	components: {Redactor},
	props: {
		saveUrl: {type: String, required: true},
		settings: {type: Object},
	},

	data(){
		return {
			body: null
		}
	},

	beforeMount() {
		window.addEventListener('LAYOUT:primary_button', this.save);

		this.body = this.settings ? this.settings.body : '';
	},

	methods: {
		save() {
			axios.post(this.saveUrl, {body: this.body})
				.then(() => {
                    Vue.$toast.open({
                        message: 'Changes saved successfully',
                        type: 'success'
                    });
                })
				.catch(error => {
					if(error.response && error.response.data){
                        Vue.$toast.open({
                            message: error.response.data.message,
                            type: 'error'
                        });
					}
				})
		}
	}
}
</script>

<style>
	.redactor-box {
		width: 100%;
	}
</style>
